// mediaActions.js

/**
 * Synthetic AddModal actions that replace multiple system media types.
 * Handled by useTopLevelNodeCreate (CAMERA → camera modal, ATTACH → mixed upload).
 */
export const ADD_MODAL_MEDIA_ACTION_KEYS = Object.freeze({
  CAMERA: 'CAMERA',
  FILES: 'ATTACH',
});

/** System types hidden from AddModal once Camera / Files are injected. */
export const CONSOLIDATED_MEDIA_TYPE_KEYS = new Set([
  'PHOTO',
  'VIDEO',
  'DOCUMENT',
  'FILE',
  'SNAPSHOT',
  'RECORDING',
]);

/**
 * Camera + Files picker cards (sorted alphabetically with other AddModal options).
 */
export const MEDIA_ACTION_DEFS = Object.freeze([
  {
    key: ADD_MODAL_MEDIA_ACTION_KEYS.CAMERA,
    label: 'Camera',
    iconKey: 'camera',
    description: 'Take a photo or record a video.',
  },
  {
    key: ADD_MODAL_MEDIA_ACTION_KEYS.FILES,
    label: 'Files',
    iconKey: 'attach_file',
    description: 'Upload photos, videos, documents, or other files.',
  },
]);

/**
 * Returns true when the key is a synthetic media action (not a node type).
 *
 * @param {string|null|undefined} typeKey
 * @returns {boolean}
 */
export function isMediaActionKey(typeKey) {
  const normalized = typeof typeKey === 'string' ? typeKey.trim().toUpperCase() : '';
  if (!normalized) return false;
  return normalized === ADD_MODAL_MEDIA_ACTION_KEYS.CAMERA
    || normalized === ADD_MODAL_MEDIA_ACTION_KEYS.FILES;
}
